// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Chapters-module__list--Xigy6 {\n  margin-bottom: 24px;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/OpeningInfo/components/Chapters/Chapters.module.less"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF","sourcesContent":[".list {\n  margin-bottom: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"list": "Chapters-module__list--Xigy6"
};
export default ___CSS_LOADER_EXPORT___;
